module.exports = __webpack_public_path__ + "static/media/50tawi.dd5126f6.pdf";